import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { ArrowRight, BookOpen } from "lucide-react";
import heroImage from "@/assets/blog-family-coloring-hero.jpg";

const HomeBlog = () => {
  return (
    <section id="blog" className="py-20 bg-background">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-foreground">
            From Our Blog
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Insights, tips, and research on the benefits of coloring for families
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <Link to="/blog/family-bonding-coloring" className="block">
            <Card className="overflow-hidden group hover:shadow-lg transition-all duration-300 cursor-pointer">
              <div className="grid md:grid-cols-2 gap-0">
                {/* Image Section */}
                <div className="relative overflow-hidden h-64 md:h-auto">
                  <img 
                    src={heroImage} 
                    alt="Family coloring together"
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  />
                  <div className="absolute top-4 left-4">
                    <span className="bg-primary text-primary-foreground px-3 py-1 rounded-full text-xs font-semibold">
                      Featured Article
                    </span>
                  </div>
                </div>

                {/* Content Section */}
                <div className="flex flex-col">
                  <CardHeader>
                    <div className="flex items-center gap-2 text-sm text-muted-foreground mb-2">
                      <BookOpen className="h-4 w-4" />
                      <span>5 min read</span>
                    </div>
                    <CardTitle className="text-2xl mb-2 group-hover:text-primary transition-colors">
                      The most colorful form of family bonding? Grab your crayons and find out
                    </CardTitle>
                    <CardDescription className="text-base">
                      Discover the science-backed benefits of coloring together as a family—from reducing stress and anxiety to improving communication and motor skills.
                    </CardDescription>
                  </CardHeader>
                  <CardContent className="mt-auto">
                    <div className="flex items-center justify-between">
                      <Button 
                        variant="default" 
                        asChild
                        data-gtm-event="blog_preview_clicked"
                        data-gtm-blog-title="Family Bonding Coloring"
                      >
                        <span className="group/btn inline-flex items-center">
                          Read Full Article
                          <ArrowRight className="ml-2 h-4 w-4 group-hover/btn:translate-x-1 transition-transform" />
                        </span>
                      </Button>
                    </div>
                  </CardContent>
                </div>
              </div>
            </Card>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default HomeBlog;